<template>
  <div class="orange-lianer">
    <img src="@/assets/img/icon995.png" class="absolute left0 top0 w100" />
    <div class="container absolute w90">
      <img src="@/assets/img/icon999.png" class="absolute w100 icon999" />
      <img src="@/assets/img/icon996.png" class="absolute w60 icon996" />
      <div class="bgf absolute left0 top0 w100 h100 wrappend">
        <div class="p30 register">
          <van-form @submit="onSubmit">
            <div class="bb row vertical">
              <span class="font18 c3">+86</span>
              <van-field
                v-model="form.phone"
                name="phone"
                label=""
                placeholder="请输入您的手机号码"
                :rules="[]"
              />
            </div>
            <div class="bb row vertical">
              <van-field
                v-model="form.smsCode"
                name="smsCode"
                label=""
                placeholder="请输入验证码"
                :rules="[]"
              />
              <div class="tc w170px" v-if="timerFlag">
                {{ timerNum }}秒后重新获取
              </div>
              <span class="w170px" @click="startSendMail" v-else>{{
                getMailMsg
              }}</span>
            </div>
            <div class="mt20">
              <van-button block type="info" color="#FF740D" native-type="submit"
                >注册</van-button
              >
            </div>
            <div class="tc c9 font12 mt20">
              <span>注册即代表阅读并同意舒昕逸家</span>
              <a
                class="blue"
                @click="$router.push({ path: '/recommend/protocol' })"
                >《商家入驻协议》</a
              >
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <!-- 错误提示框 -->
    <div
      class="fixed top0 left0 w100 h100 opacity-wrapper"
      v-show="hasError"
      @click="clearMsg(0)"
    >
      <div class="fixed tc py50 cf error">{{ msg }}</div>
    </div>
    <div
      class="fixed top0 left0 w100 h100  slide-shadow"
      @click="stopTimer()"
      v-show="sendMailFlag"
    >
      <SlideLogin
        :h5="true"
        @ok="validateSendMail"
        @close="sendMailFlag = false"
      ></SlideLogin>
      <!-- <div
        id="aliValidate"
        class="absolute aliValidate"
        @click="(e) => e.stopPropagation()"
      ></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "recommend",
  components: {},
  data() {
    return {
      form: {
        phone: "",
        smsCode: "",
      },
      hasError: false,
      msg: "",
      timer: null, //验证码定时器
      timerFlag: false, //是否显示验证码定时器
      timerNum: 60,
      sendMailFlag: false, //开始发送验证码
      getMailMsg: "获取验证码",
    };
  },
  methods: {
    validatePhone(val) {
      let reg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
      return reg.test(val);
    },
    showMsg(msg = "") {
      this.msg = msg;
      this.hasError = true;
      this.clearMsg();
    },
    clearMsg(time = 3000) {
      setTimeout(() => {
        this.hasError = false;
      }, time);
    },
    // 验证码定时器
    stopTimer() {
      this.timerNum = 60;
      this.getMailMsg = "重新获取验证码";
      this.timerFlag = false;
      this.sendMailFlag = false;
      clearInterval(this.timer);
    },
    startTimer() {
      this.timerFlag = true;
      this.timer = setInterval(() => {
        this.timerNum -= 1;
        if (this.timerNum <= 0) {
          this.timerFlag = false;
          this.timerNum = 60;
          this.getMailMsg = "重新获取验证码";
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 准备发送验证码
    startSendMail() {
      let phone = this.form.phone;
      if (phone == "") {
        this.showMsg("请输入手机号");
        return;
      }
      if (!this.validatePhone(phone)) {
        this.showMsg("请输入正确的手机号");
        return;
      }
      this.sendMailFlag = true;
    },
    // 人机验证通过，去发送验证码
    validateSendMail(params) {
      console.log("params===", params);
      this.sendMailFlag = false;
      this.$axios({
        url: this.$requests.tech.getCodeV2,
        method: "post",
        data: {
          phone: this.form.phone,
          type: "REGISTER", //REGISTER：注册，LOGIN：登录，FIND_PASSWORD：找回密码
          // captchaVerification: params.captchaVerification,
          ...params,
        },
      })
        .then((res) => {
          if (res.data.code !== 200) {
            this.stopTimer();
            this.showMsg(res.data.message || "请求失败");
            return;
          }
          this.showMsg("短信已成功发送，请耐心等待");
        })
        .catch((err) => {
          console.log("err===", err);
          this.stopTimer();
          this.showMsg("请求错误");
        });
      this.startTimer();
    },
    onSubmit() {
      if (this.form.phone == "") {
        this.showMsg("请输入手机号");
        return;
      }
      if (this.form.smsCode == "") {
        this.showMsg("请输入验证码");
        return;
      }
      this.$axios({
        url: this.$requests.tech.register,
        method: "post",
        data: {
          phone: this.form.phone,
          smsCode: this.form.smsCode,
          inviteCode: sessionStorage.getItem("inviteCode"),
          // inviteCode: "88064062608515072",
        },
      })
        .then((res) => {
          if (res.data.code !== 200) {
            this.stopTimer();
            this.showMsg(res.data.message || "请求失败");
            return;
          }
          this.$router.push({
            path: "/recommend/download",
          });
        })
        .catch((err) => {
          console.log("err===", err);
          this.stopTimer();
          this.showMsg("请求错误");
        });
    },
    record() {
      this.$axios({
        url: this.$requests.tech.generateRecord,
        method: "post",
      });
    },
  },
  mounted() {
    this.record();

    let { code } = this.$route.query;
    if (code) {
      sessionStorage.setItem("inviteCode", code);
    } else {
      sessionStorage.setItem("inviteCode", "88064062608515072");
    }
  },
};
</script>

<style lang="less" scoped>
.orange-lianer {
  height: 100%;
  background: linear-gradient(125deg, #fe562b, #ff9500);
  .container {
    left: 5%;
    bottom: 20px;
    height: 50%;
    .icon999 {
      top: -275px;
    }
    .icon996 {
      top: -110px;
      z-index: 3;
      left: 20%;
    }
    .wrappend {
      z-index: 2;
      border-radius: 10px;
      .register {
        position: absolute;
        top: 50%;
        height: 260px;
        margin-top: -130px;
      }
    }
  }
  .opacity-wrapper {
    z-index: 5;
    .error {
      top: 50%;
      left: 10%;
      margin-top: -50px;
      width: 80%;
      max-height: 200px;
      background: rgba(0, 0, 0, 0.6);
    }
  }
}
.slide-shadow {
  z-index: 2000;
  background: rgba(0, 0, 0, 0.2);
}
.aliValidate {
  top: 50%;
  left: 10%;
  width: 80%;
  height: 50px;
  margin-top: -25px;
}
</style>
